<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Acknowledgments">
<p class="fm_h1" id="sec2"><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv"><a href="#/text/9780253063526_Contents#rsec2">ACKNOWLEDGMENTS</a></span></p>
<p class="noindent_para"><span class="smallcaps">THE TRANSLATORS WISH TO GRATEFULLY</span> acknowledge the assistance of the following:</p>
<p class="noindent_parat">Barbara Mhic Con Iomaire; M.; Máirín Nic Con Iomaire &amp; Dónall Ó Braonáin; John Drever; Jennika Baines, Lesley Bolton and all at Indiana University Press; Pete Feely and team, Amnet Systems; Seosamh Ó Murchú, Eagarthóir Sinsearach, An Gúm, Foras na Gaeilge; Jonny Dillon, Cnuasach Bhéaloideas Éireann/National Folklore Collection, UCD; Aisling Keane, James Hardiman Library, NUI Galway; Nessa Cronin, Centre for Irish Studies, NUI Galway; Seathrún Ó Tuairisg, Acadamh na hOllscolaíochta Gaeilge, NUI Galway; Nuala Ford and muintir Mhic Giollarnáth, Galway; Seán Ó Mainnín Photography, An Cheathrú Rua.<span class="right_1" epub:type="pagebreak" id="page_xvi" title="xvi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253063526_Acknowledgments.vue?52b2df64